var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
// import PathSvg from './gtc_bg';
// import {Brochure as BrochureEl} from '@assets/widgets/brocure/brochure'
import { Hook } from "@assets/tsx/hook";
import Button from "@widgets/button/button";
import Ribbon from "@widgets/ribbon";
import { useA11yContext } from "@assets/spa/context/a11y";
import { Link } from "@ambiguous/link";
import RibbonSeparator from "@widgets/ribbon/ribbonSeparator";
import Image from "@assets/tsx/image";
function BrochureLtg({ title, content, content_type, links, image, buttons }) {
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && !!state && state.illustrations === true;
    return (React.createElement("div", { className: `ltg-brochure ${has_image ? 'ltg-brochure--has-image' : ''}` },
        React.createElement("div", { className: "ltg-brochure-ribbon-extention-wrap" },
            React.createElement("div", { className: "ltg-brochure-ribbon-extention" })),
        has_image && (React.createElement("div", { className: "ltg-brochure-hook-extention-wrap" },
            React.createElement(Hook, null))),
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "ltg-brochure-text-wrap" },
                React.createElement("div", { className: "ltg-brochure-text" },
                    React.createElement("h2", null, title),
                    content_type === 'links' ? React.createElement(LinksList, { items: links }) :
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
                    buttons && React.createElement(ButtonGroup, { buttons: buttons })),
                React.createElement("div", { className: "ribbon-black" },
                    React.createElement(Ribbon, { side: "left" })),
                React.createElement("div", { className: "ribbon-white" },
                    React.createElement(Ribbon, { side: "right" })),
                React.createElement("div", { className: "hook" },
                    React.createElement(Hook, null))),
            has_image && React.createElement(ImageWrap, { srcset: image === null || image === void 0 ? void 0 : image.srcset, url: image === null || image === void 0 ? void 0 : image.url, title: title }))));
}
function BrochureMuseum({ title, content, content_type, links, image, buttons }) {
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && !!state && state.illustrations === true;
    return (React.createElement("div", { className: `ltg-brochure ${has_image ? 'ltg-brochure--has-image' : ''}` },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "ltg-brochure-text-wrap" },
                React.createElement("div", { className: "ltg-brochure-text" },
                    React.createElement("h2", null, title),
                    content_type === 'links' ? React.createElement(LinksList, { items: links }) :
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: content } }),
                    buttons && React.createElement(ButtonGroup, { buttons: buttons }))),
            has_image && React.createElement(ImageWrap, { srcset: image === null || image === void 0 ? void 0 : image.srcset, url: image === null || image === void 0 ? void 0 : image.url, title: title },
                React.createElement("div", { className: "ribbon-wrap" },
                    React.createElement(RibbonSeparator, null))))));
}
// const PathGtc = THEME === 'gtc' ? React.lazy(()=>import('./gtc_bg')) : undefined;
// function BrochureGtc({title, content, buttons,content_type,links}:Brochure){
// 	return (
// 		<div className={`ltg-brochure--gtc`}>
// 			<div className="container">
// 				{PathGtc && <PathGtc />}
// 				<div className="ltg-brochure-text-wrap">
// 					<div className="ltg-brochure-text">
// 						<h2>{title}</h2>
// 						{content_type === 'links' ? <LinksList items={links} /> :
// 							<div dangerouslySetInnerHTML={{ __html: content }}>
// 							</div>
// 						}
// 						{buttons && <ButtonGroup buttons={buttons}/>}
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	)
// }
function ButtonGroup({ buttons }) {
    return (React.createElement("div", { className: "ltg-brochure-buttons" }, buttons === null || buttons === void 0 ? void 0 : buttons.map((_a) => {
        var { _id } = _a, rest = __rest(_a, ["_id"]);
        return (React.createElement(Button, Object.assign({ key: _id }, rest)));
    })));
}
function ImageWrap({ url, title, children, srcset }) {
    return (React.createElement("div", { className: "ltg-brochure-img-wrap" },
        React.createElement("div", { className: "ltg-brochure-img-content" },
            React.createElement(Image, { width: 1300, height: 1300, src: url, alt: title, srcSet: srcset, className: "ltg-brochure-img" }),
            children)));
}
function LinkItem({ url, label, blank }) {
    return React.createElement("div", { className: "ltg-brochure-link" },
        React.createElement("i", { className: "fas fa-chevron-right" }),
        React.createElement(Link, { target: blank ? '_blank' : undefined, rel: blank ? 'noopener noreferrer nofollow' : undefined, href: url }, label));
}
function LinksList({ items }) {
    return React.createElement("div", null, items === null || items === void 0 ? void 0 : items.map(({ _id, label, url, url__props }) => React.createElement(LinkItem, { key: _id, blank: url__props === null || url__props === void 0 ? void 0 : url__props.blank, label: label, url: url })));
}
let Brochure = BrochureLtg;
switch (THEME) {
    // case('gtc'):
    // 	Brochure = BrochureGtc
    // break;
    case ('museum'):
        Brochure = BrochureMuseum;
        break;
}
export { Brochure as default };
// function ThemedBrochure(props:any){
// 	let Brochure = BrochureLtg;
// 	const theme = THEME;
// 	switch(theme){
// 		// case('gtc'):
// 		// 	Brochure = BrochureGtc
// 		// break;
// 		case('museum'):
// 			Brochure = BrochureMuseum
// 		break;
// 	}
// 	return <Brochure {...props}/>
// }
// export {ThemedBrochure as default}
